<template>
  <div>
    <el-card class="box-card" body-style="min-height:60vh;">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="分公司搜索：" prop="name">
            <el-input v-model="searchForm.name" placeholder="请输入分公司名称搜索" class="mt-search-width"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button @click="toAdd('')" size="small" type="primary" class="bg-theme">添加分公司</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="enterpriseName"
            label="分公司名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="toAdd(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <el-dialog
      :title="dataId == '' ? '添加分公司' : '编辑分公司'"
      :visible.sync="dialogVisible"
      width="960px">
      <el-form :model="cateForm" label-width="140px">
        <el-form-item label="分公司名称：" prop="enterpriseName">
          <el-input style="width: 420px;" v-model="cateForm.enterpriseName" placeholder="请输入分公司名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { queryEnterprisePageList, removeEnterpriseById, saveEnterprise, updateEnterprise, fetchEnterpriseDetailById } from '@/api/branchOffice'
export default {
  name: 'BranchOffice',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      baseUrl:this.$baseUrl,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:'',
        region:''
      },
      // 添加分公司弹窗
      dataId:'',
      dialogVisible: false,
      cateForm:{
        enterpriseName:''
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      queryEnterprisePageList({ enterpriseName: searchName,pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeEnterpriseById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    /* 跳转添加 */
    toAdd (dataId) {
      this.dataId = dataId
      this.cateForm.enterpriseName = '';
      if(dataId != ''){
        let that = this
        fetchEnterpriseDetailById({ id: dataId }).then((res) => {
          if (res.errorCode === '0000') {
            let data = res.data
            that.cateForm.enterpriseName = data.enterpriseName
          }
        })
      }
      this.dialogVisible = true
    },
    // 添加-编辑
    saveBtn(){
      var that = this
      var dataId = that.dataId
      var enterpriseName = that.cateForm.enterpriseName
      if (enterpriseName === '') {
        this.$message.error('请输入分公司名称')
        return false
      }
      let passData = {
        enterpriseName: enterpriseName
      }
      if (dataId !== '') {
        passData = {
          id: dataId, enterpriseName: enterpriseName
        }
        updateEnterprise(passData).then((res) => {
          that.fullscreenLoading = false;
          if(res.errorCode == "0000"){
            that.cateForm.dataId = '';
            that.cateForm.enterpriseName = '';
            that.dialogVisible=false;
            that.currentPage = 1;
            that.getInfoList();
          }
          if(res.errorCode == "1001"){
            that.$message.error(res.msg);
          }
        })
      }else{
        saveEnterprise(passData).then((res) => {
          that.fullscreenLoading = false;
          if(res.errorCode == "0000"){
            that.cateForm.enterpriseName = '';
            that.dialogVisible=false;
            that.currentPage = 1;
            that.getInfoList();
          }
          if(res.errorCode == "1001"){
            that.$message.error(res.msg);
          }
        })
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/commission/BranchOffice.vue